"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LanguageRule_1 = require("./LanguageRule");

var LanguageState =
/** @class */
function () {
  function LanguageState(name) {
    this.name = name;
    this.rules = [];
  }

  LanguageState.create = function (name) {
    return new LanguageState(name);
  };

  LanguageState.prototype.addRule = function (token, regex, options) {
    var rule = LanguageRule_1.LanguageRule.create(token, regex, options);
    this.rules.push(rule);
    return this;
  };

  LanguageState.prototype.getName = function () {
    return this.name;
  };

  LanguageState.prototype.getRuleList = function () {
    return this.rules.map(function (rule) {
      return rule.getRule();
    });
  };

  return LanguageState;
}();

exports.LanguageState = LanguageState;